import DropdownMenu from "../../../../../../common/Menu/DropdownMenu/DropdownMenu";
import UnplannedVacationApplication from "../../../../../../../frontend.classes/Requests/UnplannedVacation.application";
import {
    getReasonBelongsTypeThunkAction,
} from "../../../../../../../redux/actions/Requests/LeaveMetadata/thunk/getReasonBelongsType.thunk.action";
import CustomUploader from "../../../../../../common/CustomUploader/CustomUploader";
import CommentInput from "../../../../../../common/Inputs/CommentInput/CommentInput";
import SinglePairDates from "../../../../../../common/Inputs/SinglePairDates/SinglePairDates";
import { emptyCurrentRequest } from "../../../../../../../redux/actions/Requests/currentRequestControls/emptyCurrentRequest";
import {
    dropdownSelectionCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/dropdownSelection.currentRequest";
import { clearAttachmentsAction } from "../../../../../../../redux/actions/Requests/Attachments/clearAttachments.action";
import {
    addCommentHandlerCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/addCommentHandler.currentRequest";
import {
    isAttachmentsAllowedThunkAction, isAttachmentsAllowedWithReasonThunkAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/thunk/isAttachmentsAllowed.thunk.action";
import {
    clearAttachmentsAllowedAction,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/isAttachmentsAllowed.action";
import {
    validationControlCurrentRequest,
} from "../../../../../../../redux/actions/Requests/currentRequestControls/validationControl.currentRequest";
import NotificationWindowRequests from "../../../../../../common/NotificationWindowRequests/NotificationWindowRequests";

import { isTerminal } from "../../../../../../../constants";

import { useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";

isTerminal ? import("./UnplannedVacationTerminal.scss") : import("./UnplannedVacation.scss");

function UnplannedVacation({ setRequestStatus, requestStatus, requestOption }) {
    const [searchParams] = useSearchParams();
    const queryId = searchParams.get("id");
    const dispatch = useDispatch();
    const isUserAttachmentsAllowed = useSelector(state => state.requests.isUserAttachmentsAllowed);
    const reasons = useSelector((state) => state.requests.reasons);
    const currentRequest = useSelector(
        (state) => state.requests.currentRequest,
    );

    const [notificationWindow, setNotificationWindow] = useState(false);

    function selectDropdown(event, element, stateProperty) {
        if(stateProperty === "leaveReasonId") {
            dispatch(isAttachmentsAllowedWithReasonThunkAction(
                {
                    requestTypeId: requestOption ,
                    reasonTypeId: element.id,
                }
            ));
        }
        dispatch(
            dropdownSelectionCurrentRequest({ event, element, stateProperty }),
        );
    }

    function commentHandler(event) {
        dispatch(validationControlCurrentRequest("employeeComment", true));
        dispatch(addCommentHandlerCurrentRequest(event.target.value));
    }

    useEffect(() => {
        dispatch(
            emptyCurrentRequest(
                new UnplannedVacationApplication({ leaveTypeId: 2 }),
            ),
        );
        setRequestStatus(false);
        dispatch(clearAttachmentsAction());
        dispatch(getReasonBelongsTypeThunkAction(requestOption));
        if(queryId) {
            if (currentRequest && currentRequest?.leaveReasonId) {
                dispatch(isAttachmentsAllowedWithReasonThunkAction(
                    {
                        requestTypeId: currentRequest.leaveTypeId,
                        reasonTypeId: currentRequest.leaveReasonId,
                    }
                ));
            }
        }  else {
            dispatch(isAttachmentsAllowedThunkAction({requestTypeId: requestOption }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
        return () => {
            dispatch(clearAttachmentsAction());
            dispatch(clearAttachmentsAllowedAction());
        };
    }, [queryId]);

    useEffect(() => {
        if (requestStatus && !requestStatus.isSuccess) {
            setNotificationWindow(true);
        }
    }, [requestStatus]);

    return (
        <section className={"unplanned-vacation"}>
            <DropdownMenu
                currentRequest={currentRequest}
                styleName={"unplanned-reason"}
                label={<>Выберите причину отпуска <span className="required_text"> *</span></>}
                listOfOptions={reasons}
                stateProperty={"leaveReasonId"}
                isValidKey={
                    currentRequest &&
                    currentRequest.isValid &&
                    currentRequest.isValid.leaveReasonId
                        ? currentRequest.isValid.leaveReasonId
                        : false
                }
                selectOptionClick={selectDropdown}
            />
            <SinglePairDates />
            <CommentInput
                maxLength={255}
                value={currentRequest && currentRequest.employeeComment}
                changeHandler={commentHandler}
                label={"Комментарий"}
                parentStyle={"extra-vacation-days"}
                helper={
                    " Пожалуйста, расшифруйте причину необходимости предоставления " +
                    "отпуска. Обращаем внимание: комментарий будет доступен всем " +
                    "согласующим."
                }

            />
            {!isTerminal &&
                isUserAttachmentsAllowed ?
                <CustomUploader /> : null
            }
            <NotificationWindowRequests
                notificationWindowStatus={requestStatus}
                setNotificationWindowStatus={setRequestStatus}
                notificationWindowStyle={notificationWindow}
            />
        </section>
    );
}

export default UnplannedVacation;
